import styled from 'common/styled-components';

export const PaddedFormItem = styled.div`
  margin: 5px;
`;